import { Link, List, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { UploadDocumentType } from "../../../types";
import { useStageOptOutCheckbox } from "../hooks";
import { useFundingApplication, useFundingApplicationMutation } from "../../../queries/funding-application/queries";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const CashFlowForecastDocumentUpload = ({
  includeHeader = false,
  error,
}: {
  includeHeader?: boolean;
  error?: string;
}): UIElement => {
  const intl = useIntl();

  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { data: fundingApplication } = useFundingApplication(customerDomain);
  const fundingApplicationMutation = useFundingApplicationMutation(customerDomain);
  const { useLegacyCheckbox, canOptOutOfStage } = useStageOptOutCheckbox(UploadDocumentType.CASH_FLOW_FORECAST);

  const handleSkipCheckbox = async (checked: boolean) => {
    await fundingApplicationMutation.mutateAsync({ id: fundingApplication.id, isCashflowForecastSkipped: checked });
  };

  return (
    <DocumentUpload
      documentType={UploadDocumentType.CASH_FLOW_FORECAST}
      supportedFileExtensions={[".xlsx", ".csv", ".pdf"]}
      fileSizeLimitMB={50}
      header={includeHeader ? intl.formatMessage(MESSAGES.revenueProjectionsTitle) : undefined}
      description={
        <List type="bullet">
          <List.Item>
            <Text>
              {intl.formatMessage(MESSAGES.revenueProjectionsDescriptionPoint1, {
                a: (chunks: string) => (
                  <Link
                    url="https://docs.google.com/spreadsheets/d/1Y3cDnEuB134Zd8z4tLJY5ageeQUpNHMRwHPST4TrXnI/edit?gid=0#gid=0"
                    external
                  >
                    {chunks}
                  </Link>
                ),
              })}
            </Text>
          </List.Item>
          <List.Item>
            <Text>{intl.formatMessage(MESSAGES.cashFlowForecastDescriptionPoint2)}</Text>
          </List.Item>
        </List>
      }
      onSkipCheckbox={useLegacyCheckbox ? undefined : canOptOutOfStage ? handleSkipCheckbox : undefined}
      skipped={fundingApplication.isCashflowForecastSkipped}
      error={error}
    />
  );
};
